import "./GoogleMapPicker.css";

function GoogleMapPicker({ providerData }) {

  const address = providerData.address || {};

  return (

    <div className="google-map-picker">

      <h3>

        Business Location

      </h3>

      <p>

        Your business location will appear here after selecting
        your current location. Google Maps integration will be
        enabled in a later phase.

      </p>

      <div className="map-preview">

        <div className="map-icon">

          📍

        </div>

        <h4>

          Google Maps Preview

        </h4>

        <span>

          Coming Soon

        </span>

      </div>

      {

        address.latitude && address.longitude && (

          <div className="coordinates">

            <div>

              <strong>Latitude</strong>

              <p>{address.latitude}</p>

            </div>

            <div>

              <strong>Longitude</strong>

              <p>{address.longitude}</p>

            </div>

          </div>

        )

      }

    </div>

  );

}

export default GoogleMapPicker;